<template>
    <div class="replenishment-update clearfix">
        <compFormEdit
            ref="editForm"
            class="margin-layout"
            :formdata="getBase"
            v-model="formData"
            :labelWidth="120"
        ></compFormEdit>
        <div class="button-container pull-right">
            <Button class="margin-right-15" type="primary" @click="submit">确定</Button>
            <Button type="default" @click="cancel">取消</Button>
        </div>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import mixin from "./mixin";
import {
    HttpGetReplenishMentDetail,
    HttpUpdateReplenishment
} from "@/service/replenishmentcycle";
export default {
    mixins: [mixin],
    props: ['activeid'],
    data() {
        return {
            formData: {},
            loading: false
        };
    },
    async created () {
        this.loading = true;
        await this.getDetail();
        this.loading = false;
    },
    computed: {
        getBase() {
            return [
                {
                    label: "运输类型",
                    tag: "vInput",
                    key: "transportTypeName",
                    query: true,
                },
                {
                    label: "发运港",
                    key: "portCode",
                    tag: "vInput",
                    query: true,
                },
                {
                    label: "目的仓",
                    key: "orgWarehouseCode",
                    query: true,
                },
                {
                    label: "货物筹备装柜期",
                    key: "loadingDay",
                    tag: "vInput",
                    required: false,
                },
                {
                    label: "装柜到开船等待期",
                    key: "loadingShipDay",
                    tag: "vInput",
                    required: false,
                },
                {
                    label: "目的港卸货周期",
                    key: "unloadingPortDay",
                    tag: "vInput",
                    required: false,
                },
                {
                    label: "提柜周期",
                    key: "pickUpDay",
                    tag: "vInput",
                    required: false,
                },
                {
                    label: "预约送仓",
                    key: "reserveWarehouseDay",
                    tag: "vInput",
                    required: false,
                },
                {
                    label: "还空柜周期",
                    key: "emptyPickUpDay",
                    tag: "vInput",
                    required: false,
                },
                {
                    label: "发运周期",
                    key: "shipDay",
                    tag: "vInput",
                    required: false,
                },
            ];
        },
    },
    methods: {
        async getDetail () {
            await HttpGetReplenishMentDetail({
                id: this.activeid
            }).then(res => {
                this.formData = res.data;
            }, err => {
                this.$VMessage.error(err.message);
            });
        },
        cancel () {
            this.$emit('on-close');
        },
        async submit () {
            await this.$refs.editForm.validate();
            await HttpUpdateReplenishment({
                ...this.formData
            }).then(res => {
                this.$VMessage.success(res.message);
                this.$emit('on-update');
                this.cancel();
            }, err => {
                this.$VMessage.error(err.message);
            });
        },
    }
};
</script>

<style>
</style>